import React, { useState } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useGetPublicProfile, UserData } from '@vatom/sdk/react'
import { Actionsheet, Box } from 'native-base'

import Alert from '../../../components/Alert'
import { useMaxWith } from '../../../components/WebWrapper'
import logger from '../../../logger'
import { CameraScanner } from '../../Camera/partials/CameraScanner'

interface ActionSheetCameraProps {
  setOpen: (b: boolean) => void
  isOpen: boolean
  processLink: (link: string) => void
}

export const ActionSheetCamera = ({ isOpen, setOpen, processLink }: ActionSheetCameraProps) => {
  logger.info('ActionSheetCamera')
  const maxWidth = useMaxWith()

  if (!isOpen) {
    return null
  }

  return (
    <Actionsheet
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      maxWidth={maxWidth}
      margin={'auto'}
      useRNModal={true}
      // @ts-ignore prop doesn't exit on types
      _backdropFade={{
        entryDelay: 150,
        exitDelay: 10
      }}
    >
      <Box left={0} right={0} position={'absolute'} bottom={0} top={0} safeAreaTop>
        <CameraScanner
          onScanner={data => {
            data.data && processLink(data.data)
          }}
          onClose={() => setOpen(false)}
        />
      </Box>
    </Actionsheet>
  )
}
export default ActionSheetCamera

export const ActionSheetCameraScannerUser = (props: {
  setOpen: (b: boolean) => void
  isOpen: boolean
  processLink: (constact: UserData) => void
}) => {
  const { processLink: onSucces, ...rest } = props
  const [contactId, setContactId] = useState<string>()

  useGetPublicProfile(contactId, {
    enabled: !!contactId,
    onSuccess: contact => {
      if (contactId) {
        logger.info('contact', contact)
        if (contact && contact.id) {
          onSucces(contact)
          return
        }

        Alert.fire({
          title: 'Contact not found',
          text: 'Please try again'
        })
      }
    }
  })

  const processLink = (link: string) => {
    // https://wallet.vatom.com/receive/0e37v9l
    const id = link.split('/').pop()
    if (id) setContactId(id)
  }
  return <ActionSheetCamera processLink={processLink} {...rest} />
}
